import React, { Component } from "react";
import { connect } from "react-redux";
import ContentLoader from "react-content-loader";
import BackButton from "../../../elements/BackButton";
import { getFeedback } from "../../../redux/Teacher/user/action";
import ProgressiveImage from "react-progressive-image";
import { IMAGE_BASE_URL } from "../../../api";
import img from "../../../assets/Images/online-test-nodata.svg";
import teacherImg from "../../../assets/Images/bg.png";
import Moment from "react-moment";
import { AiFillStar } from "react-icons/ai";

class TeacherFeedback extends Component {
    state = {
        loading: true,
    };

    componentDidMount() {
        this.setState({ loading: true });
        const { teacher } = this.props;

        if (teacher?.data?.auth_token) {
            this.props.getFeedback(teacher.data.auth_token);
        }
        setTimeout(() => {
            this.setState({ loading: false });
        }, 800);
    }

    render() {
        const { feedback } = this.props;
        const feedbackList = feedback?.data || [];
        const avgRating = feedback?.avg_rating || 0;
        const totalReviews = feedback?.total_reviews || feedbackList.length || 0;

        return (
            <React.Fragment>
                {this.state.loading ? (
                    <React.Fragment>
                        <div className="px-2 w-100">
                            <BackButton title={"Feedbacks & Reviews"} />
                        </div>
                        <div className="p-3">
                            <ContentLoader
                                viewBox="0 0 280 500"
                                backgroundColor={"#F3F3F3"}
                                foregroundColor={"#FFFFFF"}
                            >
                                <rect x="10" y="10" rx="12" ry="12" width="260" height="90" />
                                <rect x="10" y="120" rx="12" ry="12" width="260" height="85" />
                                <rect x="10" y="215" rx="12" ry="12" width="260" height="85" />
                                <rect x="10" y="310" rx="12" ry="12" width="260" height="85" />
                            </ContentLoader>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="px-2 w-100">
                            <BackButton title={"Feedbacks & Reviews"} />
                        </div>

                        {/* Average Rating Summary Card */}
                        <div className="px-3 mt-3">
                            <div
                                className="p-3 rounded-4 shadow-sm text-center position-relative overflow-hidden"
                                style={{
                                    background: "linear-gradient(135deg, #c1486f 0%, #ce5f53 100%)",
                                    color: "#FFF",
                                }}
                            >
                                <div className="fw-bold display-4 mb-0" style={{ lineHeight: "1" }}>
                                    {avgRating > 0 ? avgRating : "N/A"}
                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-1 my-2">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <AiFillStar
                                            key={star}
                                            size={22}
                                            color={star <= Math.round(avgRating) ? "#FFD700" : "rgba(255, 255, 255, 0.4)"}
                                        />
                                    ))}
                                </div>
                                <div style={{ fontSize: "13px", opacity: 0.9, fontWeight: "500" }}>
                                    {totalReviews} Parent {totalReviews === 1 ? "Review" : "Reviews"}
                                </div>
                            </div>
                        </div>

                        {/* Feedback List */}
                        {feedbackList.length > 0 ? (
                            <div className="d-flex flex-column gap-3 mt-4 px-3 mb-5">
                                <div className="fw-bold px-1" style={{ fontSize: "16px", color: "#212529" }}>
                                    All Reviews
                                </div>
                                {feedbackList.map((item, index) => {
                                    const rating = item?.rating || 5;
                                    const studentUser = item?.student?.user;
                                    const studentName = studentUser?.name || "Parent";

                                    return (
                                        <div
                                            key={item.id || index}
                                            className="p-3 rounded-3 bg-white shadow-sm border"
                                            style={{ borderLeft: "4px solid #c1486f" }}
                                        >
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <ProgressiveImage
                                                        delay={20}
                                                        src={IMAGE_BASE_URL + studentUser?.image}
                                                        placeholder={teacherImg}
                                                    >
                                                        {(src) => (
                                                            <img
                                                                src={src}
                                                                style={{
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    borderRadius: "50%",
                                                                    objectFit: "cover",
                                                                    border: "1px solid #c1486f",
                                                                }}
                                                                alt={studentName}
                                                            />
                                                        )}
                                                    </ProgressiveImage>
                                                    <div className="d-flex flex-column">
                                                        <span className="fw-bold" style={{ fontSize: "14px", color: "#212529" }}>
                                                            {studentName}
                                                        </span>
                                                        {item?.created_at && (
                                                            <span className="text-muted" style={{ fontSize: "11px" }}>
                                                                <Moment format="DD MMM YYYY">{item.created_at}</Moment>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center gap-1 bg-light px-2 py-1 rounded-pill">
                                                    <AiFillStar size={16} color="#FFC107" />
                                                    <span className="fw-bold" style={{ fontSize: "12px", color: "#212529" }}>
                                                        {rating}.0
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                className="p-2 rounded-2 mt-2"
                                                style={{ backgroundColor: "#F8F9FA", fontSize: "14px", color: "#495057" }}
                                            >
                                                "{item?.feedback}"
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center mt-5 py-4">
                                <img src={img} alt="no-review" style={{ width: "160px" }}></img>
                                <div className="text-muted mt-3 fw-bold" style={{ fontSize: "15px" }}>
                                    No Reviews Available Yet
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    teacher: state.teacher.teacher,
    feedback: state.teacher.feedback,
});

export default connect(mapStateToProps, { getFeedback })(TeacherFeedback);
